import { render } from "./LoadingIndicator.vue?vue&type=template&id=36e3bf2f"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js"

import "./LoadingIndicator.vue?vue&type=style&index=0&id=36e3bf2f&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
